import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Episodes from "./pages/Episodes";
import Characters from "./pages/Characters";
import About from "./pages/About";
import EpisodeDetail from "./pages/EpisodeDetail";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/episodes" element={<Episodes />} />
          <Route path="/episodes/:n" element={<EpisodeDetail />} />
          <Route path="/characters" element={<Characters />} />
          <Route path="/about" element={<About />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
